<!-- <div (click)="goToRestaurant()" 
         class="group cursor-pointer bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
      <!-- Image Container --
      <div class="relative h-48 overflow-hidden">
        <img [src]="restaurant.image" [alt]="restaurant.name" 
             class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
        <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        
        <!-- Restaurant Logo --
        <div class="absolute bottom-0 right-5 w-14 h-14 rounded-full bg-white shadow-lg p-0.5 overflow-hidden border-0 border-white">
          <img [src]="restaurant.logo" [alt]="restaurant.name + ' logo'" 
               class="w-full h-full object-cover rounded-full" />
        </div>

        <!-- Rating Badge --
        <!-- <div class="absolute top-3 left-3 bg-white/95 backdrop-blur-sm rounded-full px-2 py-1 flex items-center space-x-1">
          <lucide-icon name="star" class="w-3.5 h-3.5 text-yellow-500 fill-yellow-500"></lucide-icon>
          <span class="text-xs font-semibold text-gray-800">{{ restaurant.rating }}</span>
        </div> --
      </div>

      <!-- Content --
      <div class="p-4">
        <h3 class="text-lg font-bold text-gray-900 group-hover:text-orange-500 transition-colors">
          {{ restaurant.name }}
        </h3>
        <p class="text-sm text-gray-500 mt-1 line-clamp-1">{{ restaurant.tagline }}</p>

        <!-- Meta Info --
        <div class="flex items-center justify-between mt-3 pt-3 border-t border-gray-100">
          <!-- <div class="flex items-center text-gray-500 text-xs">
            <lucide-icon name="clock" class="w-3.5 h-3.5 mr-1"></lucide-icon>
            {{ restaurant.deliveryTime }}
          </div>
          <span class="text-xs text-gray-400">{{ restaurant.cuisine }}</span>
        </div> --

        <!-- Offer Badge --
        <div class="mt-3 flex items-center">
          <lucide-icon name="tag" class="w-4 h-4 text-teal-500 mr-1.5"></lucide-icon>
          <span class="text-sm font-medium text-teal-600">{{ restaurant.offer }}</span>
        </div>
      </div>
    </div> -->

<!-- 
<div (click)="goToRestaurant()"
  class="group cursor-pointer bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 relative">


  <div class="relative h-48 overflow-hidden rounded-t-2xl">
    <img [src]="restaurant.image + '?ts=' + timestamp" [alt]="restaurant.name"
      class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
    <div class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>


  </div>


  <div
    class="absolute bottom-48 right-5 w-[74px] h-[74px] rounded-full bg-white shadow-xl p-0 overflow-hidden border-2 border-white z-10">
    <img [src]="restaurant.logo + '?ts=' + timestamp" [alt]="restaurant.name + ' logo'" class="w-full h-full object-cover rounded-full" />
  </div>

  <div class="p-4 pt-3">
    <h3 class="text-lg font-bold text-gray-900 group-hover:text-orange-500 transition-colors">
      {{ restaurant.name }}
    </h3>
      <div class="box-border flex items-center justify-between mb-1">
      <span class="text-xs text-gray-400 mb-1">{{ restaurant.cuisine }}</span>
    </div>
    <div class="flex items-center border-t border-gray-100 h-7">
    <p class="text-sm text-gray-500 line-clamp-1">{{ restaurant.tagline }}</p>
    </div>
  
    <hr class="mb-3 border-gray-100">
    <div class="flex items-center justify-between bg-teal-50 rounded-lg p-2">

 
      <div class="flex flex-col justify-start text-[#e31212]">
        <span style="line-height: 3px;font-weight: bold;" class="text-[8px] leading-[10px]">Select Partner</span>
        <span class="text-sm font-medium text-teal-600">Order Now</span>
      </div>

    
      <div class="flex items-center gap-3 ml-auto">
        <img class="h-5 object-cover block" src="../../../../assets/img/swiggy.png" alt="Swiggy" />
        <span class="inline-block w-px h-7 bg-gradient-to-b from-transparent to-transparent"
          style="background-image: linear-gradient(to bottom, transparent, #0D9488 60%, transparent);">
        </span>
        <img class="h-5 object-cover block" src="../../../../assets/img/zomato.png" alt="Zomato" />
      </div>

    </div>


    <div class="mt-3 flex items-center bg-teal-50 rounded-lg p-2">
      <lucide-icon name="tag" class="w-4 h-4 text-teal-500 mr-1.5"></lucide-icon>
      <span class="text-sm font-medium text-teal-600">{{ restaurant.offer }}</span>
    </div>
  </div>
</div> -->




<div
  class="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 relative">

  <div class="relative h-48 overflow-hidden rounded-t-2xl cursor-pointer"
    (click)="!restaurant.isOn ? null : goToRestaurant()" [class.opacity-100]="!restaurant.isOn"
    [class.cursor-pointer]="restaurant.isOn" [class.cursor-not-allowed]="!restaurant.isOn">
    <img [src]="restaurant.image + '?ts=' + timestamp" [alt]="restaurant.name"
      class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
    <div class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>

    <!-- Coming Soon Overlay -->
    <!-- <div *ngIf="!restaurant.isOn" 
      class="absolute inset-0 bg-black/50 flex items-center justify-center z-20">
      <div class="bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-lg">
        <span class="text-sm font-bold text-gray-800">Coming Soon</span>
      </div>
    </div> -->
    <!-- <div *ngIf="!restaurant.isOn"
      class="absolute inset-0 bg-black/40 backdrop-blur-[2px] flex items-center justify-center z-20">
      <div class="relative bg-white/95 rounded-xl px-6 py-3 shadow-xl overflow-hidden">
        <div
          class="absolute inset-0 bg-gradient-to-r from-orange-500 via-pink-500 to-purple-500 animate-spin-slow opacity-75">
        </div>
        <div class="relative bg-white rounded-lg px-4 py-2">
          <span class="text-sm font-bold bg-gradient-to-r from-orange-500 to-pink-500 bg-clip-text text-transparent">✨
            Coming Soon ✨</span>
        </div>
      </div>
    </div> -->

    <div *ngIf="!restaurant.isOn"
      class="absolute inset-0 bg-gradient-to-br from-black/60 to-black/30 backdrop-blur-[0px] flex items-center justify-center z-20 rounded-t-2xl will-change-transform">
      <div class="bg-white/95 rounded-2xl px-6 py-3 shadow-2xl transform animate-pulse">
        <div class="flex items-center gap-2">
          <!-- <span class="text-xl">🔜</span> -->
          <span class="text-sm font-bold text-red-800 tracking-wide">COMING SOON</span>
          <!-- <span class="text-xl">✨</span> -->
        </div>
      </div>
    </div>

  </div>

  <!-- <div
    class="absolute bottom-48 right-5 w-[74px] h-[74px] rounded-full bg-white shadow-xl p-0 overflow-hidden border-2 border-white z-10">
    <img [src]="restaurant.logo + '?ts=' + timestamp" [alt]="restaurant.name + ' logo'"
      [class.blur]="!restaurant.isOn" class="w-full h-full object-cover rounded-full" />
  </div> -->
  <div
    class="absolute bottom-48 right-5 w-[74px] h-[74px] rounded-full bg-white shadow-xl p-0 overflow-hidden border-2 border-white z-10"
    (click)="!restaurant.isOn ? null : goToRestaurant()" [class.opacity-100]="!restaurant.isOn"
    [class.cursor-pointer]="restaurant.isOn" [class.cursor-not-allowed]="!restaurant.isOn">
    <img [src]="restaurant.logo + '?ts=' + timestamp" [alt]="restaurant.name + ' logo'"
      class="w-full h-full object-cover rounded-full" />

    <!-- Add this overlay for logo when restaurant is off -->
    <div *ngIf="!restaurant.isOn"
      class="absolute inset-0 bg-gradient-to-br from-black/60 to-black/30 rounded-full flex items-center justify-center">
      <!-- <div class="text-xs">🔒</div> -->
    </div>
  </div>
  <div class="p-4 pt-3">
    <h3 class="text-lg font-bold text-gray-900 group-hover:text-orange-500 transition-colors"
      [class.text-gray-500]="!restaurant.isOn">
      {{ restaurant.name }}
    </h3>
    <div class="box-border flex items-center justify-between mb-1">
      <span class="text-xs text-gray-400 mb-1">{{ restaurant.cuisine }}</span>
    </div>
    <div class="flex items-center border-t border-gray-100 h-7">
      <p class="text-sm text-gray-500 line-clamp-1">{{ restaurant.tagline }}</p>
    </div>
    <hr class="mb-3 border-gray-100">
    <div class="flex items-center justify-between bg-teal-50 rounded-lg p-2">
      <div class="flex flex-col justify-start text-[#e31212]">
        <span style="line-height: 3px;font-weight: bold;" class="text-[8px] leading-[10px]">Select Partner</span>
        <span class="text-sm font-medium text-teal-600">Order Now</span>
      </div>
      <div class="flex items-center gap-3 ml-auto">
        <img class="h-5 object-cover block cursor-pointer" src="../../../../assets/img/swiggy.png" alt="Swiggy"
          (click)="redirectToPartner(restaurant.id, 'Swiggy')" />
        <span class="inline-block w-px h-7 bg-gradient-to-b from-transparent to-transparent"
          style="background-image: linear-gradient(to bottom, transparent, #0D9488 60%, transparent);">
        </span>
        <img class="h-5 object-cover block cursor-pointer" src="../../../../assets/img/zomato.png" alt="Zomato"
          (click)="redirectToPartner(restaurant.id, 'Zomato')" />
      </div>
    </div>

    <div class="mt-3 flex items-center bg-teal-50 rounded-lg p-2">
      <lucide-icon name="tag" class="w-4 h-4 text-teal-500 mr-1.5"></lucide-icon>
      <span class="text-sm font-medium text-teal-600">{{ restaurant.offer }}</span>
    </div>
  </div>
</div>

<!-- 
<div (click)="goToRestaurant()"
     class="group relative cursor-pointer bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">

  <div class="relative h-48 overflow-hidden">
    <img [src]="restaurant.image"
         [alt]="restaurant.name"
         class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />

    <div class="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
  </div>

  <div class="absolute -bottom-7 right-5 w-14 h-14 rounded-full bg-white shadow-lg p-0.5">
    <img [src]="restaurant.logo"
         [alt]="restaurant.name + ' logo'"
         class="w-full h-full object-cover rounded-full" />
  </div>

  <div class="p-4 pt-10">
    <h3 class="text-lg font-bold text-gray-900 group-hover:text-orange-500 transition-colors">
      {{ restaurant.name }}
    </h3>

    <p class="text-sm text-gray-500 mt-1 line-clamp-1">
      {{ restaurant.tagline }}
    </p>

    <div class="mt-3 flex items-center">
      <lucide-icon name="tag" class="w-4 h-4 text-teal-500 mr-1.5"></lucide-icon>
      <span class="text-sm font-medium text-teal-600">
        {{ restaurant.offer }}
      </span>
    </div>
  </div>

</div> -->